<ds-root
  [shouldShowFullscreenLoader]="(isAuthBlocking$ | async) || (isThemeLoading$ | async)"
  [shouldShowRouteLoader]="isRouteLoading$ | async"></ds-root>

@if (browserPlatform) {
  <ds-social></ds-social>
}
